import React from "react";
import { FileDownloadOutlined } from "@mui/icons-material";
import { Paper } from "@mui/material";

interface LicenseCardProps {
  title: string;
  fileName: string;
  fileUrl: string;
  onDownload?: () => void;
  onPreview?: () => void;
  testId: string;
}

const LicenseCard: React.FC<LicenseCardProps> = ({
  title,
  fileName,
  onDownload,
  onPreview,
  testId,
}) => {
  return (
    <Paper variant="outlined" data-testid={testId} className="p-4 w-full rounded">
      <h3 className="font-bold mb-2">{title}</h3>

      <div className="flex justify-start items-center mb-2 w-full">
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline break-all cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            onPreview?.();
          }}
        >
          {fileName}
        </a>

        <button
          type="button"
          onClick={onDownload}
          className="cursor-pointer text-left ml-auto"
          title="Download"
        >
          <FileDownloadOutlined />
        </button>
      </div>
    </Paper>
  );
};

export default LicenseCard;
